/**
* Rolling List JS
* -----------------------------------------------------------------------------
*
* All the JS for the Rolling List component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'rolling-list',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.rolling-list' ).each( function( key, val ) {
        const list = $( this ).find( '.rolling-list__list-inner' )[0];
        const amountToScroll = $( this ).find( '.rolling-list__list' ).innerHeight() - $( this ).find( '.rolling-list__list-inner' ).height() + 32;

        let navHeight = $( '.navbar' ).height();
        if ( $( 'body' ).hasClass( 'logged-in' ) ) {
          navHeight = navHeight + $( '#wpadminbar' ).height();
        }

        if ( amountToScroll < 0 ) {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: $( this ).find( '.rolling-list__list-wrapper' )[0],
              pin: true,
              start: 'top ' + navHeight,
              end: '=+' + ( amountToScroll * -1 ),
              onUpdate: ( self ) => {
                if ( self.progress > .95 ) {
                  $( val ).find( '.rolling-list__list' ).addClass( 'is-finished' );
                } else {
                  $( val ).find( '.rolling-list__list' ).removeClass( 'is-finished' );
                }
              },
              scrub: 0,
              // markers: true,
            },
          } );
          tl.to( list, {y: amountToScroll, ease: 'linear'}, 0 );
        } else {
          $( this ).find( '.rolling-list__list-wrapper' ).removeClass( 'is-rolling' );
          ScrollTrigger.refresh();
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'rolling-list', COMPONENT );
} )( app );
